import { getDateTime } from '../../../helpers/utils'
import AuthPermission from '../../../high-order-components/auth-permission'
import translate from '../../../i18n'
import {
  ISalesCampaign,
  SalesCampaignStatusEnums,
} from '../../../pages/sales-campaigns-container/share-type'
import { PermissionsEnum } from '../../../share-types'
import YesOrNoTag from '../../common/YesOrNoTag'
import LinkButton from '../../link-button/link-button'
import { Button, Descriptions, Image, Tag } from 'antd'
import { connect, ConnectedProps } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { compose } from 'redux'

interface IProps extends ConnectedProps<typeof withConnect> {
  salesCampaign: ISalesCampaign
}

const SalesCampaignDescriptions = (props: IProps) => {
  const { salesCampaign } = props
  const navigate = useNavigate()
  const toEdit = () => {
    navigate(`/sales-campaigns/${salesCampaign.id}/edit`)
  }

  return (
    <Descriptions
      style={{ width: 1200 }}
      title={translate('salesCampaign.detailTitle')}
      styles={{ label: { alignItems: 'center', fontWeight: 600 } }}
      column={2}
      bordered
      extra={
        <AuthPermission permission={PermissionsEnum.SALES_CAMPAIGN_WRITE}>
          <Button onClick={toEdit} type="primary">
            {translate('edit')}
          </Button>
        </AuthPermission>
      }
    >
      <Descriptions.Item label="ID">{salesCampaign?.id}</Descriptions.Item>
      <Descriptions.Item label={translate('name')}>{salesCampaign?.name}</Descriptions.Item>
      <Descriptions.Item label={translate('salesCampaign.enableCouponReminder')}>
        <YesOrNoTag value={salesCampaign?.enableCouponReminder} />
      </Descriptions.Item>
      <Descriptions.Item label={translate('salesCampaign.couponTemplate')}>
        {salesCampaign?.couponTemplateId && (
          <LinkButton to={`/coupon-templates/${salesCampaign.couponTemplateId}`}>
            {salesCampaign.couponTemplateName}
          </LinkButton>
        )}
      </Descriptions.Item>
      <Descriptions.Item label={translate('salesCampaign.plan')}>
        {salesCampaign?.planName}
      </Descriptions.Item>
      <Descriptions.Item label={translate('salesCampaign.floatingPortal')}>
        {salesCampaign?.floatingPortalUrl && (
          <Image
            src={salesCampaign.floatingPortalUrl}
            style={{ maxWidth: '50px', maxHeight: '50px' }}
          />
        )}
      </Descriptions.Item>
      <Descriptions.Item label={translate('salesCampaign.chargeBanner')}>
        {salesCampaign?.chargeBannerUrl && (
          <Image
            src={salesCampaign.chargeBannerUrl}
            style={{ maxWidth: '50px', maxHeight: '50px' }}
          />
        )}
      </Descriptions.Item>
      <Descriptions.Item label={translate('status')}>
        <Tag color={salesCampaign?.status === SalesCampaignStatusEnums.INACTIVE ? 'red' : 'green'}>
          {salesCampaign?.status}
        </Tag>
      </Descriptions.Item>
      <Descriptions.Item label={translate('salesCampaign.startDatetime')}>
        {salesCampaign?.startDatetime ? getDateTime(salesCampaign.startDatetime) : ''}
      </Descriptions.Item>
      <Descriptions.Item label={translate('salesCampaign.endDatetime')}>
        {salesCampaign?.endDatetime ? getDateTime(salesCampaign.endDatetime) : ''}
      </Descriptions.Item>
    </Descriptions>
  )
}

const mapStateToProps = () => {
  return {}
}

const withConnect = connect(mapStateToProps)

export default compose(withConnect)(SalesCampaignDescriptions)
